import React, { Component } from "react";
import { toast } from "react-toastify";
import * as yup from "yup";
import { ErrorMessage } from "components/shared/ErrorMessage";
import _ from "lodash";
import legacyProductService from "services/admin/masters/legacyProductService";
import Spinner from "components/shared/Spinner";
import { MSG_CREATE_RECORD, MSG_UPDATE_RECORD, TEXT_MIN_LENGTH, TEXT_MAX_LENGTH } from "constants/admin/masters/legacyProducts";
import Breadcrumb from "components/shared/Breadcrumb";
import { handleChange, handleTouched,formFailure,getCurrentSlug,trimFields } from "utils/masterHelpers";
const serviceObj = new legacyProductService();
class Form extends Component {
  constructor(props) {
    super(props);
    this.handleChange=handleChange.bind(this);
    this.handleTouched=handleTouched.bind(this);
    this.formFailure=formFailure.bind(this);
    this.getCurrentSlug=getCurrentSlug.bind(this);
    this.trimFields=trimFields.bind(this); 

    this.state = {
      isEditForm: false,
      Id: 0,
      formReady: false,
      isSubmitting: false,
      errors: {},
      touched: {},
      form: {
        title: "",
        //description:"",
        product_id: 0,
      },
      flatProducts: [],
      breadcrumbs:[{ title: 'Legacy Product List', url: '/admin/master/'+this.getCurrentSlug() },
                   { title: 'Legacy Product' }
                  ]
    };
  }

  componentDidMount = async () => {
    const { Id } = this.props.match.params;
    await serviceObj.getAllDropdown(Id || 0).then((response) => {
      this.setState({
        flatProducts: response,
      });
    });
    if (Id > 0) {
      //repopulate the form
      this.setState({
        Id,
        isEditForm: true,
      });
      const Info = await serviceObj.getDetail(Id);
      const form = this.state.form;
      form.title = Info.title;
      //form.description = Info.description;
      form.product_id = Info.product_id;
      this.setState(
        {
          form,
        },
        () => {
          this.setState({
            formReady: true,
          });
        }
      ); //populate in form
    } else {
      //do any preload any api call if needed in caseof add form then make the form ready to load
      this.setState({
        formReady: true,
      });
    }
  }; 
  submitForm = async (e) => {
    e.preventDefault();
    this.trimFields(this.state.form);
    this.setState({
      isSubmitting: true,
    });
    const errors = await this.validateForm();
    if (_.isEmpty(errors)) {
      //now proceed to save user
      const form = this.state.form;
      try {
        let response;
        if (this.state.Id > 0 && this.state.isEditForm) {
          response = await serviceObj.update(form, this.state.Id);
        } else {
          response = await serviceObj.create(form);
        }
        if (response) {
          toast.success(response.message || (this.state.isEditForm) ? MSG_UPDATE_RECORD : MSG_CREATE_RECORD);
          this.props.history.push("/admin/master/"+this.getCurrentSlug());
        }
      } catch (err) {
        //failure case
        this.formFailure();
        if (err) {
          const errors = this.state.errors;
          for (const [field, msg] of Object.entries(err)) {
            errors[field] = msg[0];
          }
          await this.setState({
            errors,
          });
        }
      }
    } else {
      //failure case
      this.formFailure();
    }
  }; 
  validateForm = async () => {
    const errors = {};
    const schema = yup.object().shape({
      title: yup.string().required().min(TEXT_MIN_LENGTH).max(TEXT_MAX_LENGTH),
      product_id: yup.number().required().positive('please select a product.'),
    });
    // check validity
    await schema
      .validate(this.state.form, { abortEarly: false })
      .catch(function (err) {
        err.inner.map((error) =>
          !errors[error.path] ? (errors[error.path] = error.message) : null
        );
      });

    this.setState({
      errors,
    });
    return errors; //return basicerrors
  }; 
  populateSimiliarTitle=async (e)=>{
    const {Id,form,flatProducts}=this.state;
    if(Id===0 && form.title===""){      
      const selectedProductId=e.target.value;
      const productInfo=flatProducts.find(itm=>itm.id===parseInt(selectedProductId));
      form.title=productInfo.name;
      await this.setState(form);
      this.handleTouched("title");
      this.validateForm();
    }
  }
  render() {
    const {
      isSubmitting,
      form,
      touched,
      errors,
      isEditForm,
      formReady,
      flatProducts,
      breadcrumbs
    } = this.state;
    return (
      <div className="form-wrap mt-3">
        {isSubmitting ? <Spinner /> : null}
        {formReady ? (
          <div className="form-group">
            <Breadcrumb data={breadcrumbs} isEdit={isEditForm} />
            <form onSubmit={this.submitForm}>

              <div className="form-group">
                <label htmlFor="product_id">Product</label>
                <select
                  name="product_id"
                  onChange={(e)=>{this.handleChange(e); this.populateSimiliarTitle(e)}}
                  value={form.product_id}
                  //disabled={isEditForm}
                  className={`form-control ${
                    touched.product_id && errors.product_id
                      ? "is-invalid"
                      : ""
                    }`}
                >
                  <option key="-1" value="0">
                    --SELECT--
                  </option>
                  {flatProducts.length
                    ? flatProducts.map((product, index) => (
                      <option key={index} value={product.id}>
                        {product.name}
                      </option>
                    ))
                    : null}
                </select>
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="product_id"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label htmlFor="name">
                 Legacy Product Title
                </label>
                <input
                  type="text"
                  name="title"
                  placeholder="Enter legacy product name"
                  onChange={this.handleChange}
                  value={form.title}
                  className={`form-control ${
                    touched.title && errors.title
                      ? "is-invalid"
                      : ""
                    }`}
                />
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="title"
                  className="text-danger"
                />
              </div>
              {/*<div className="form-group">
                <label htmlFor="description">
                 Legacy product Description
                </label>
                <textarea
                  name="description"
                  placeholder="Description"
                  onChange={this.handleChange}
                  value={form.description}
                  className={`form-control ${
                    touched.description && errors.description
                      ? "is-invalid"
                      : ""
                    }`}
                ></textarea>
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="description"
                  className="text-danger"
                />
                  </div>*/}

              <button
                type="submit"
                className="btn btn-secondary btn-block"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? "Please wait..."
                  : isEditForm
                    ? "Update"
                    : "Add"}
              </button>
            </form>
          </div>
        ) : (
            <Spinner />
          )}
      </div>
    );
  }
}

export default Form;
